import {  Edit, Trash2 } from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Brand from "../../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../../Router/all_routes";
import CommonMaterialReactTable from "../../MaterialReactTable/CommonMaterialReactTable";
import apiHandler from "../../common/api";
import { Box } from "@mui/material";
import "sweetalert2/dist/sweetalert2.min.css";
import config from "../../../config";
import HeaderModule from "../../components/Header/HeaderModule";

const BusinessTypeList = () => {
  const navigate = useNavigate();
  const [productlist, setProductlist] = useState([]);
  const [deletes, setdelete] = useState(false);
  const MySwal = withReactContent(Swal);
  const showConfirmationAlert = (ID) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(ID);
        MySwal.fire({
          title: "Deleted!",
          text: "Your business type has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const handleDelete = async (id) => {
    let reqobj = {
      ID: id,
      Module: "businessType",
    };
    const response = await apiHandler({
      method: "POST",
      route: "Superadmin/deletebymoduleid",
      payload: reqobj,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      // showConfirmationAlert();
      setdelete(!deletes);
    } else {
      console.log(response, "data");
    }
  };
  const columns = [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      // sortingFn: "numeric",
    },
    {
      header: "businessType Name",
      accessorKey: "businessTypeName",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "businessType Description",
      accessorKey: "businessTypeDescription",
      enableSorting: true,
      sortingFn: "alphanumeric",
    },
    {
      header: "businessType logo",
      accessorKey: "businessTypelogo",
      enableSorting: true,
      sortingFn: "alphanumeric",
      // Cell: ({ row }) => (
      //   <img
      //     src={config.Imageurl + row.original.businessTypelogo}
      //     alt={row.original.businessTypeName}
      //     style={{ width: "50px", height: "50px", objectFit: "cover" }}
      //   />
      // ),
      Cell: ({ row }) => (
        <img
        src={
         
          row.original.businessTypelogo == 0 
            ? "https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg"
            :  config.Imageurl + row.original.businessTypelogo
        }
        alt={row.original.businessTypeName || "No Image Available"}
        style={{ width: "50px", height: "50px", objectFit: "cover" }}
      />
      
      ),
    },
    {
      accessorKey: "actions",
      header: "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          <button
            // color="primary"
            className="btn btn-outline-primary btn-sm me-2"
            onClick={() => {
              navigate(`${route.BusinessType}/${row.original.ID}`);
              console.log("Edit row:", row.original.ID);
            }}
          >
            <Edit  className='custome-icon-size' />
          </button>
          <button
           className="btn btn-outline-primary btn-sm me-2"
            // color="error"
            onClick={() => {
              
              showConfirmationAlert(row.original.ID)
            }}
          >
            <Trash2  className='custome-icon-size' />
          </button>
        </Box>
      ),
    },
  ];

  const route = all_routes;

  console.log(route, "route7889")

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/BusinessTypeList`,
    });
    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setProductlist(response.ResponseData);
    } else {
      console.log(response, "data");
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [deletes]);

  const exportData = productlist.map((item) => ({
    ID: item?.ID,
    businessTypeName: item?.businessTypeName,
    businessTypeDescription: item?.businessTypeDescription,
  }));

  return (
    <div className="page-wrapper">
      <div className="content">
        <HeaderModule
          refreshData={prodcutDataListApi}
          exportData={exportData}
          addMasterPageLink={route.BusinessType}
        />

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-responsive">
              <CommonMaterialReactTable columns={columns} data={productlist} />
            </div>
          </div>
        </div>
        {/* /product list */}
        <Brand />
      </div>
    </div>
  );
};

export default BusinessTypeList;
